import { useMemo } from 'react';
import { api } from '@/redux/api';
import { Organisation } from '@/types/organisation';
import { useUserRole } from './use-user-role';

export const useOrganisations = () => {
  const { isPlatformAdmin } = useUserRole();

  const result = api.useGetOrganisationsQuery(undefined, {
    skip: !isPlatformAdmin,
  });

  const data = useMemo<Organisation[]>(() => result.data ?? [], [result.data]);

  return { ...result, data };
};
